/* template */
<template><div class="conditions-wrap"><div class="conditions-title">{{$t('common.conditions')}}</div><div class="conditions-detail"><div class="order-records-statement">{{ $t('goodsDetail.orderRecordsStatement') }}</div><mpx-text @tap="toLaw" class="link-law">{{$t('common.tapAndView')}}<span class="icon-arrow"></span></mpx-text></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m8071a734"}'>
@import "../../lib/stylus/variable.styl"
.conditions-wrap
  background: #FCFDFE;
  padding 39rpx
  .conditions-title
    font-weight: $fw-semi-bold;
    font-size: 30rpx;
    color: #333333;
    line-height: 28rpx;
    margin-bottom 30rpx
  .conditions-detail
    font-size: 26rpx;
    color: #666666;
    text-align: justify;
    // word-break: break-all;
    line-height: 44rpx;
    .icon-arrow
      width: 10rpx;
      height: 17rpx;
      margin-left: 13rpx;
      display: inline-block;
      background-image: url(https://dpubstatic.udache.com/static/dpubimg/9B-gkgBDQ3/icon_arrow.png);
      background-position: center center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { toLaw } from '../../lib/webx/utils/ui'
createComponent({
  methods: {
    toLaw() {
      toLaw()
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "conditions8071a734",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-text':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
